export const SEARCH_DEBOUNCE_DELAY = 1000;
export const SEARCH_RESULTS = 'Below listed are the search results for the typed in keyword:';
export const FILTER = 'Filter : ';
export const SEARCH_CATEGORY = 'Categories';
export const SEARCH_SUB_CATEGORY = 'Sub Categories';
export const SEARCH_INDICATORS = 'Indicators';
export const NO_RECORDS_FOUND = 'No records found';
